var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.210965 4.04062C0.208826 4.09108 0.217031 4.14145 0.235076 4.18862C0.253121 4.23579 0.280624 4.27877 0.315895 4.31492C0.351165 4.35107 0.393457 4.37962 0.44017 4.39882C0.486884 4.41802 0.53703 4.42746 0.587527 4.42656H1.87659C2.09221 4.42656 2.26409 4.25 2.29221 4.03594C2.43284 3.01094 3.13596 2.26406 4.38909 2.26406C5.46096 2.26406 6.44221 2.8 6.44221 4.08906C6.44221 5.08125 5.85784 5.5375 4.9344 6.23125C3.88284 6.99531 3.05003 7.8875 3.1094 9.33594L3.11409 9.675C3.11573 9.77751 3.15761 9.87527 3.23069 9.94718C3.30377 10.0191 3.40219 10.0594 3.50471 10.0594H4.7719C4.8755 10.0594 4.97486 10.0182 5.04811 9.94496C5.12137 9.87171 5.16253 9.77235 5.16253 9.66875V9.50469C5.16253 8.38281 5.58909 8.05625 6.74065 7.18281C7.69221 6.45937 8.6844 5.65625 8.6844 3.97031C8.6844 1.60938 6.69065 0.46875 4.50784 0.46875C2.52815 0.46875 0.359402 1.39062 0.210965 4.04062ZM2.64378 13.0453C2.64378 13.8781 3.30784 14.4937 4.2219 14.4937C5.17346 14.4937 5.82815 13.8781 5.82815 13.0453C5.82815 12.1828 5.1719 11.5766 4.22034 11.5766C3.30784 11.5766 2.64378 12.1828 2.64378 13.0453Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.8efcf9798c3cd1f49f994d43765b2ccd.svg";
export { ForwardRef as ReactComponent };